import { db } from "../../firebase/firebase";
import {
  collection,
  getDocs,
  setDoc,
  doc
} from "firebase/firestore";

/* -------------------------------------------------------
   IMPORT MIGRATIONS
   <---- Add new migration imports here
------------------------------------------------------- */
import migration1 from "./migrations/1_testUpdate";
import migration2 from "./migrations/2_addProductLocation";
// import migration3 from "./migrations/3_anotherUpdate";

export async function Update(detectOnly = false) {
  console.log("Checking for pending migrations...");

  /* -------------------------------------------------------
     DEFINE MIGRATIONS ARRAY
     <---- Add new migrations to this array
  ------------------------------------------------------- */
  const migrations = [
    migration1,
    migration2,
    // migration3
  ];

  const appliedSnap = await getDocs(collection(db, "migrations"));
  const applied = appliedSnap.docs.map((d) => d.data().version);

  const pending = migrations.filter(m => !applied.includes(m.version));

  if (pending.length === 0) {
    console.log("NO_MIGRATIONS");
    return;
  }

  console.log("MIGRATIONS_EXIST");

  if (detectOnly) {
    console.log("Detection mode: updates exist.");
    return;
  }

  for (const migration of pending) {
    console.log(`Applying migration v${migration.version}: ${migration.name}`);

    await migration.run(); // <---- Your update logic runs here

    await setDoc(doc(db, "migrations", migration.version.toString()), {
      version: migration.version,
      name: migration.name,
      appliedAt: new Date()
    });

    console.log(`✔ Migration v${migration.version} applied`);
  }

  console.log("✔ All pending migrations applied");
}
